import React from 'react';
import { useParams } from 'react-router';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getTechnicalRoomPpr, getDefectTypes, getPositions } from './api';

export const path = '/ppr/area/list/:areaId/:realEstateId/:id';
export const getPath = (areaId: string, realEstateId: string, id: string) =>
  `/ppr/area/list/${areaId}/${realEstateId}/${id}`;

const PageTechnicalRoomPpr: React.FC = (props) => {
  const { id } = useParams<{ id: string }>();

  const TechnicalRoomPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      technicalRoom: () => getTechnicalRoomPpr(id),
      positions: getPositions,
      defectTypes: getDefectTypes,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <TechnicalRoomPpr {...props} />;
};

export default PageTechnicalRoomPpr;
